// Auto generated file, do not manually modify!
// com.hotpads.rentalmanagerapi.api.web.v2.users.properties.feedtomanual.RentalManagerUserPropertyFeedToManualV2WebApiHandler

import { getClient } from '../../client';
import { httpFrontEndRequest } from '@zg-rentals/ts-client-http-client';

import type { UserPropertyFeedToManualConvertRequestDto, UserPropertyFeedToManualConvertV2ResponseWebDto } from '../..';

export const RentalManagerUserPropertyFeedToManualV2WebApiHandler_convert_Path =
  '/api/web/v2/users/properties/feedToManual/convert';

/**
 * Convert a feed listing to manual listing
 */
export const RentalManagerUserPropertyFeedToManualV2WebApiHandler_convert = (
  postData: UserPropertyFeedToManualConvertRequestDto,
  client = getClient(),
) => {
  return httpFrontEndRequest<
    never,
    UserPropertyFeedToManualConvertRequestDto,
    UserPropertyFeedToManualConvertV2ResponseWebDto
  >(
    {
      endpoint: RentalManagerUserPropertyFeedToManualV2WebApiHandler_convert_Path,
      method: 'POST',
      contextPath: '/rental-manager-api',
      postData: postData,
    },
    client,
  );
};
